import {needAuth} from "../instance/Instance";
import {getPages} from "../../components/commonmethod/CommonMethod";

export async function getCliams(search, pageable) {
    pageable.sort = [pageable.sort, "id"]
    try{
        const res = await needAuth.post('/claims/list?'+getPages(pageable),search);
        return  res;
    }catch (error){
        return error;
    }
}

export async function deleteClaim(data) {
    const queryString = `id=${data.join(',')}`;
    console.log(queryString)
    try {
        return await needAuth.delete(`/claims?${queryString}`);
    } catch (error) {
        return error;
    }
}

